import toast from 'react-hot-toast';

// Toda confirmação de ação no painel administrativo (criar, salvar, excluir,
// bloquear, ativar/desativar etc.) mostra o horário exato ao lado da
// mensagem — dá pra saber na hora "quando exatamente isso aconteceu", sem
// precisar ir no log de auditoria pra conferir. Não é usado nas páginas
// públicas de voto (Portal, Telão, dinâmicas) — lá o toast é só uma
// confirmação simples pro visitante, sem contexto de auditoria.
function horarioAgora() {
  return new Date().toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export function sucessoComHorario(mensagem, options) {
  return toast.success(`${mensagem} — ${horarioAgora()}`, options);
}
